/*
  New Well — Sepet ödülleri (Kaching yerine)
  - Sepet tutarı eşiği geçince hediye ürünü otomatik ekler, düşünce çıkarır.
  - Hediye satırı "_nw_hediye" özelliğiyle işaretlenir; adedi 1'de tutulur.
  - Güvenlik: Shopify indirimi hediyeyi 0 TL yapmıyorsa (indirim kurulmamışsa)
    hediye geri çıkarılır; müşteri yanlışlıkla ücret ödemez.
  - Sepet teklifleri "Sepete Ekle" butonlarını yönetir.
  Ayarlar: sections/cart-drawer.liquid içindeki #nw-sepet-ayar JSON'u.
*/
(() => {
  if (window.__nwSepet) return;
  window.__nwSepet = true;

  const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const asilFetch = window.fetch.bind(window);
  const JSON_BASLIK = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let indirimYok = false;

  const ayar = () => {
    try {
      return JSON.parse(document.getElementById('nw-sepet-ayar').textContent);
    } catch (e) {
      return null;
    }
  };
  const hediyeMi = (item) => item.properties && item.properties._nw_hediye;

  const sepetiGetir = async () => (await asilFetch(`${kok}cart.js`, { headers: { Accept: 'application/json' } })).json();
  const gonder = (yol, govde) =>
    asilFetch(`${kok}${yol}`, { method: 'POST', headers: JSON_BASLIK, body: JSON.stringify(govde) });

  // Temanın sepet çekmecesini ve sepet sayacını güncelle
  async function temaYenile() {
    const sepet = await sepetiGetir();
    const govde = document.querySelector('[id^="CartDrawerBody-"]');
    const bolumId = govde ? govde.id.replace('CartDrawerBody-', '') : null;
    if (bolumId) {
      try {
        const r = await asilFetch(`${kok}?sections=${encodeURIComponent(bolumId)}`);
        sepet.sections = await r.json();
      } catch (e) {}
    }
    if (window.FoxTheme && FoxTheme.pubsub && sepet.sections) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: sepet, source: 'nw-sepet' });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  let calisiyor = false;
  let tekrar = false;

  // Hediyeyi sepetle eşitle. Değişiklik yaptıysa true döner.
  async function esitle() {
    const a = ayar();
    if (!a || !a.aktif || !a.hediyeVaryant) return false;
    if (calisiyor) {
      tekrar = true;
      return false;
    }
    calisiyor = true;
    let degisti = false;
    try {
      const sepet = await sepetiGetir();
      const hediyeler = sepet.items.filter(hediyeMi);
      const hediyeTutar = hediyeler.reduce((t, i) => t + i.final_line_price, 0);
      const toplam = sepet.total_price - hediyeTutar;
      const digerUrunVar = sepet.items.some((i) => !hediyeMi(i));
      const hakEdiyor = !indirimYok && a.hediyeStokta && digerUrunVar && toplam >= a.esik;

      if (hakEdiyor && hediyeler.length === 0) {
        const r = await gonder('cart/add.js', {
          items: [{ id: a.hediyeVaryant, quantity: 1, properties: { _nw_hediye: '1' } }],
        });
        degisti = r.ok;
        if (r.ok) {
          // Güvenlik kontrolü: indirim uygulanmadıysa hediyeyi geri çıkar
          const kontrol = await sepetiGetir();
          const eklenen = kontrol.items.find(hediyeMi);
          if (eklenen && eklenen.final_line_price > 0) {
            indirimYok = true;
            console.warn('[New Well] Hediye indirimi Shopify\'da tanımlı değil; hediye sepetten çıkarıldı.');
            await gonder('cart/change.js', { id: eklenen.key, quantity: 0 });
          }
        }
      } else if (!hakEdiyor && hediyeler.length) {
        for (const h of hediyeler) await gonder('cart/change.js', { id: h.key, quantity: 0 });
        degisti = true;
      } else if (hakEdiyor && (hediyeler.length > 1 || hediyeler[0].quantity > 1)) {
        await gonder('cart/change.js', { id: hediyeler[0].key, quantity: 1 });
        for (const h of hediyeler.slice(1)) await gonder('cart/change.js', { id: h.key, quantity: 0 });
        degisti = true;
      }

      if (degisti) await temaYenile();
    } catch (e) {
      console.warn('[New Well] Sepet eşitleme hatası', e);
    } finally {
      calisiyor = false;
      if (tekrar) {
        tekrar = false;
        planla();
      }
    }
    return degisti;
  }

  let zamanlayici;
  function planla() {
    clearTimeout(zamanlayici);
    zamanlayici = setTimeout(esitle, 400);
  }

  // Tema veya başka bir script sepeti değiştirdiğinde haberdar ol
  window.fetch = function (girdi, secenek) {
    const istek = asilFetch(girdi, secenek);
    try {
      const adres = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(adres)) istek.then(planla, () => {});
    } catch (e) {}
    return istek;
  };

  // Sepet teklifleri
  document.addEventListener('click', async (e) => {
    const kaydir = e.target.closest('[data-nw-teklif-kaydir]');
    if (kaydir) {
      const liste = kaydir.parentElement.querySelector('[data-nw-teklif-liste]');
      if (liste) liste.scrollBy({ left: Number(kaydir.dataset.nwTeklifKaydir) * liste.clientWidth, behavior: 'smooth' });
      return;
    }

    const btn = e.target.closest('[data-nw-teklif-ekle]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-yukleniyor');
    try {
      const r = await gonder('cart/add.js', { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] });
      if (!r.ok) throw new Error('eklenemedi');
      const degisti = await esitle();
      if (!degisti) await temaYenile();
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('is-yukleniyor');
      btn.textContent = 'Eklenemedi';
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', planla);
  else planla();
})();
